<!-- Hero Section -->
<section class="hero-section" role="banner">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <h1 class="hero-title">Contáctanos</h1>
        <p class="hero-description">
          ¿Tienes preguntas sobre nuestros servicios? ¿Quieres agendar un diagnóstico gratuito? 
          Estamos aquí para ayudarte a cumplir la Ley 2466 y crear un ambiente laboral más inclusivo.
        </p>
        <div class="hero-stats">
          <div class="stat-item">
            <span class="stat-number">24h</span>
            <span class="stat-label">Respuesta</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">100%</span>
            <span class="stat-label">Gratuito</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">5+</span>
            <span class="stat-label">Canales</span>
          </div>
        </div>
        <div class="hero-actions">
          <button class="btn btn-light btn-lg px-4" (click)="agendarDiagnostico()">
            <i class="fas fa-calendar-alt me-2"></i>Agendar diagnóstico gratuito
          </button>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="hero-image">
          <img src="assets/images/contacto.png" alt="Contacto IncluTec" class="img-fluid">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Main Content -->
<main>
  <!-- Información de Contacto -->
  <section class="contact-info py-5 bg-light">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 mb-4">
          <div class="contact-card text-center p-4 bg-white rounded shadow-sm h-100">
            <div class="contact-icon mb-3">
              <i class="fas fa-map-marker-alt fa-3x text-primary"></i>
            </div>
            <h4>Ubicación</h4>
            <p class="text-muted mb-0">
              Medellín, Colombia<br>
              Oficina principal en el centro empresarial
            </p>
          </div>
        </div>
        <div class="col-lg-4 mb-4">
          <div class="contact-card text-center p-4 bg-white rounded shadow-sm h-100">
            <div class="contact-icon mb-3">
              <i class="fas fa-phone fa-3x text-primary"></i>
            </div>
            <h4>Teléfono</h4>
            <p class="text-muted mb-0">
              +57 (4) 123-4567<br>
              Lunes a Viernes: 8:00 AM - 6:00 PM
            </p>
          </div>
        </div>
        <div class="col-lg-4 mb-4">
          <div class="contact-card text-center p-4 bg-white rounded shadow-sm h-100">
            <div class="contact-icon mb-3">
              <i class="fas fa-envelope fa-3x text-primary"></i>
            </div>
            <h4>Email</h4>
            <p class="text-muted mb-0">
              contacto&#64;inclutec.co<br>
              Respuesta en menos de 24 horas
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Formulario de Contacto -->
  <section class="contact-form py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="card border-0 shadow">
            <div class="card-header bg-primary text-white text-center py-4">
              <h3 class="mb-0">Envíanos tu mensaje</h3>
              <p class="mb-0">Te responderemos en menos de 24 horas</p>
            </div>
            <div class="card-body p-4">
              <form [formGroup]="contactoForm" (ngSubmit)="onSubmit()">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="nombre" class="form-label">Nombre completo *</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      id="nombre"
                      formControlName="nombre"
                      [class.is-invalid]="submitted && f['nombre'].errors"
                      placeholder="Tu nombre completo">
                    <div class="invalid-feedback" *ngIf="submitted && f['nombre'].errors">
                      <div *ngIf="f['nombre'].errors['required']">El nombre es requerido</div>
                      <div *ngIf="f['nombre'].errors['minlength']">El nombre debe tener al menos 2 caracteres</div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="email" class="form-label">Email *</label>
                    <input 
                      type="email" 
                      class="form-control" 
                      id="email"
                      formControlName="email"
                      [class.is-invalid]="submitted && f['email'].errors"
                      placeholder="tu@email.com">
                    <div class="invalid-feedback" *ngIf="submitted && f['email'].errors">
                      <div *ngIf="f['email'].errors['required']">El email es requerido</div>
                      <div *ngIf="f['email'].errors['email']">Ingresa un email válido</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="empresa" class="form-label">Empresa *</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      id="empresa"
                      formControlName="empresa"
                      [class.is-invalid]="submitted && f['empresa'].errors"
                      placeholder="Nombre de tu empresa">
                    <div class="invalid-feedback" *ngIf="submitted && f['empresa'].errors">
                      <div *ngIf="f['empresa'].errors['required']">La empresa es requerida</div>
                      <div *ngIf="f['empresa'].errors['minlength']">La empresa debe tener al menos 2 caracteres</div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="telefono" class="form-label">Teléfono *</label>
                    <input 
                      type="tel" 
                      class="form-control" 
                      id="telefono"
                      formControlName="telefono"
                      [class.is-invalid]="submitted && f['telefono'].errors"
                      placeholder="3172794810 (10 dígitos)">
                    <div class="invalid-feedback" *ngIf="submitted && f['telefono'].errors">
                      <div *ngIf="f['telefono'].errors['required']">El teléfono es requerido</div>
                      <div *ngIf="f['telefono'].errors['minlength']">El teléfono debe tener exactamente 10 dígitos</div>
                      <div *ngIf="f['telefono'].errors['maxlength']">El teléfono debe tener exactamente 10 dígitos</div>
                      <div *ngIf="f['telefono'].errors['pattern']">Ingresa solo números, espacios y guiones (ej: 3172794810)</div>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label for="asunto" class="form-label">Asunto *</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="asunto"
                    formControlName="asunto"
                    [class.is-invalid]="submitted && f['asunto'].errors"
                    placeholder="¿En qué podemos ayudarte?">
                  <div class="invalid-feedback" *ngIf="submitted && f['asunto'].errors">
                    <div *ngIf="f['asunto'].errors['required']">El asunto es requerido</div>
                    <div *ngIf="f['asunto'].errors['minlength']">El asunto debe tener al menos 5 caracteres</div>
                  </div>
                </div>

                <div class="mb-3">
                  <label for="mensaje" class="form-label">Mensaje *</label>
                  <textarea 
                    class="form-control" 
                    id="mensaje"
                    rows="5"
                    formControlName="mensaje"
                    [class.is-invalid]="submitted && f['mensaje'].errors"
                    placeholder="Cuéntanos más detalles sobre tu consulta..."></textarea>
                  
                  <!-- Contador de caracteres -->
                  <div class="form-text d-flex justify-content-between">
                    <small class="text-muted">
                      Mínimo 15 caracteres requeridos
                    </small>
                    <small [class.text-danger]="f['mensaje'].value?.length < 15" 
                           [class.text-success]="f['mensaje'].value?.length >= 15">
                      {{ f['mensaje'].value?.length || 0 }}/15
                    </small>
                  </div>
                  
                  <div class="invalid-feedback" *ngIf="submitted && f['mensaje'].errors">
                    <div *ngIf="f['mensaje'].errors['required']">El mensaje es requerido</div>
                    <div *ngIf="f['mensaje'].errors['minlength']">El mensaje debe tener al menos 15 caracteres (actualmente tienes {{ f['mensaje'].value?.length || 0 }})</div>
                  </div>
                </div>

                <div class="mb-4">
                  <div class="form-check">
                    <input 
                      class="form-check-input" 
                      type="checkbox" 
                      id="consentimiento"
                      formControlName="consentimiento"
                      [class.is-invalid]="submitted && f['consentimiento'].errors">
                    <label class="form-check-label" for="consentimiento">
                      Autorizo el tratamiento de mis datos para ser contactado por IncluTec *
                    </label>
                    <div class="invalid-feedback" *ngIf="submitted && f['consentimiento'].errors">
                      Debes aceptar el consentimiento para continuar
                    </div>
                  </div>
                </div>

                <!-- Indicador de progreso del formulario -->
                <div class="mb-4">
                  <div class="progress mb-2" style="height: 8px;">
                    <div class="progress-bar" 
                         [class.bg-success]="contactoForm.valid"
                         [class.bg-warning]="!contactoForm.valid && submitted"
                         [class.bg-secondary]="!contactoForm.valid && !submitted"
                         [style.width.%]="getFormProgress()">
                    </div>
                  </div>
                  <small class="text-muted">
                    <span *ngIf="contactoForm.valid" class="text-success">
                      <i class="fas fa-check-circle me-1"></i>Formulario completo ✓
                    </span>
                    <span *ngIf="!contactoForm.valid && submitted" class="text-warning">
                      <i class="fas fa-exclamation-triangle me-1"></i>Revisa los campos marcados
                    </span>
                    <span *ngIf="!contactoForm.valid && !submitted" class="text-secondary">
                      <i class="fas fa-info-circle me-1"></i>Completa todos los campos requeridos
                    </span>
                  </small>
                </div>

                <!-- reCAPTCHA Component -->
                <div class="mb-4">
                  <re-captcha 
                    #recaptcha
                    [siteKey]="recaptchaSiteKey"
                    (resolved)="onRecaptchaResolved($event)"
                    size="invisible">
                  </re-captcha>
                  
                  <!-- reCAPTCHA Status Indicator -->
                  <div class="recaptcha-status p-3 rounded" 
                       [class.bg-success]="recaptchaToken"
                       [class.bg-warning]="!recaptchaToken">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-shield-alt me-2"></i>
                      <span *ngIf="!recaptchaToken" class="text-dark">
                        <i class="fas fa-clock me-2"></i>
                        Verificación de seguridad pendiente
                      </span>
                      <span *ngIf="recaptchaToken" class="text-white">
                        <i class="fas fa-check-circle me-2"></i>
                        Verificación de seguridad completada ✓
                      </span>
                    </div>
                  </div>
                </div>

                <div class="text-center">
                  <button 
                    type="button" 
                    class="btn btn-primary btn-lg px-5"
                    (click)="executeRecaptchaAndSubmit()"
                    [disabled]="loading || !contactoForm.valid">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    <i *ngIf="!loading" class="fas fa-paper-plane me-2"></i>
                    {{ loading ? 'Enviando...' : 'Enviar mensaje' }}
                  </button>
                  
                  <!-- Help text for reCAPTCHA -->
                  <div class="mt-3 text-muted small">
                    <i class="fas fa-info-circle me-1"></i>
                    Este sitio está protegido por reCAPTCHA y se aplican la 
                    <a href="https://policies.google.com/privacy" target="_blank" class="text-decoration-none">Política de Privacidad</a> 
                    y los 
                    <a href="https://policies.google.com/terms" target="_blank" class="text-decoration-none">Términos de Servicio</a> 
                    de Google.
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="cta-section py-5 bg-primary text-white">
    <div class="container text-center">
      <h3 class="mb-4">¿Necesitas ayuda inmediata?</h3>
      <p class="lead mb-4">
        Nuestro equipo de expertos está disponible para resolver tus dudas sobre la Ley 2466 
        y ayudarte a implementar la inclusión laboral en tu empresa.
      </p>
      <div class="d-flex flex-wrap gap-3 justify-content-center">
        <button class="btn btn-light btn-lg px-4" (click)="agendarDiagnostico()">
          <i class="fas fa-calendar-check me-2"></i>Agendar consulta gratuita
        </button>
      </div>
    </div>
  </section>
</main>
